<template>
  <o-scroll>
    <div class="p-4 sm:p-10">
      <div v-for="(option, key) in options" :key="key" class="mb-4">
        <integration-option v-model="_options[key].currentValue" :option="option" :integration="integration" :option-key="key" />
      </div>
    </div>
  </o-scroll>
</template>

<script setup lang="ts">
import IntegrationOption from '@/components/integration/edit/Option.vue'
import {
  TextField,
} from '@/components/fields'

interface Props {
  integration: Record<string, any>
  options: Record<string, any> | any[]
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:options', value: any): void
}>()

const _options = computed({
  get () {
    return props.options
  },
  set (options: any) {
    emit('update:options', options)
  },
})
</script>
